import config from '@/utils/config'

const mApi = {
  /* 	商品列表（首页）
       入参：
        customerId   --- 用户id
       */
  goodsListHome: function(customerId) {
    return fly.get(config.mallApi + `goods/list/home?customerId=${customerId}`);
  },
  /* 商品详情
        customerId  用户id
        id          商品id
        */
  goodsDetail: function(customerSeq, id) {
    /*
            info: {
                bottlerNumber: 装瓶数量
                bottlingTime ：装瓶时间
                brandName : 品牌名称
                brandId : 品牌ID
                price ： 价格
                fullName ：商品名称
                image ：商品图片
                enName ： 英文名称
                alcoholStrength ：酒精度
                productType ： 类型
                volumn ：净含量
            }
            */
    return fly.get(config.mallApi + `goods/detail/${customerSeq}/${id}`);
  },

  /* 商品列表 （全部）
        brandId  品牌ID
        categoryId  一级分类ID
        current    当前第几页
        size       每页记录数
        customerSeq  用户seq
        volumeValueId  净含量值ID
        */
  goodsListAll: function(postData) {
    return fly.post(config.mallApi + "goods/list/all", postData);
  },
  /* 移动端首页 （商城）
   */
  appHome: function() {
    return fly.get(config.mallApi + "app/home");
  },
  /*	商品搜索页
        name: 关键字
        current：当前页
        size： 每页记录数
        */
  goodsSearch(postData) {
    return fly.post(config.mallApi + "goods/search", postData);
  },
  /*	正在抢购
        size  current
        */
  goodsListBuying(postData) {
    return fly.post(config.mallApi + "goods/list/buying", postData);
  },
  /*	即将开始 抢购
        size  current
        */
  goodsListFutureBuying(postData) {
    return fly.post(config.mallApi + "goods/list/future/buying", postData);
  },
  /*	限时抢购列表 （全部）
        size  current
        */
  goodsListBuyingAll(postData) {
    return fly.post(config.mallApi + "goods/list/buying/all", postData);
  },
  /*	历史抢购
        size  current
        */
  goodsListHistoryBuying(postData) {
    return fly.post(config.mallApi + "goods/list/history/buying", postData);
  },
  /*	收藏 取消收藏
        productId  商品id
        operation  0（取消） 1（关注）
        */
  centerFavoritSet(productId, operation) {
    return fly.get(config.mallApi + "center/favorit/set/" + productId + "/" + operation);
  },
  /*	搜索商品
        name  商品名称
        current  size  customerSeq
        searchType  0：综合排序 1.人气高到低 2. 人气低到高 3. 销量从高到低 4.销量从低到高5.价格从高到低 6.价格从低到高
        minPrice  最小价格
        maxprice  最大价格
        brandId   品牌ID
        categoryId   一级分类ID
        volumeValueId	净含量值ID
        */
  goodsSearchAll(postData) {
    return fly.post(config.mallApi + "goods/search/all", postData);
  },
  /* 	提交订单
        addressId 收货地址id
        goods 数组  订单的商品信息 {productDetailId 规格的id   productId 商品id   quantity 数量}
        invoiceSeq 发票id （猜的）
        type  不知道
        memo  备注
        */
  orderSubmit(postData) {
    return fly.post(config.mallApi + "order/submit", postData);
  },
  /*	收货地址列表  center/address/list order/invoice/default
        size  current
        */
  centerAddressList() {
    return fly.get(config.mallApi + "center/address/list?size=20&current=1");
  },
  /*	默认发票信息  order/invoice/default
   */
  orderInvoiceDefault() {
    return fly.get(config.mallApi + "order/invoice/default");
  },
  /*	默认收货地址  order/invoice/default
   */
  defaultAddress() {
    return fly.get(config.mallApi + "center/address/default/detail");
  },
  /*	新增收货地址	center/address/add

        */
  centerAddressAdd(postData) {
    return fly.post(config.mallApi + "center/address/add", postData);
  },
  /*	删除收货地址	center/address/del

        */
  centerAddressDel(delId) {
    return fly.get(config.mallApi + "center/address/del/" + delId);
  },
  /*	修改收货地址	center/address/edit

        */
  centerAddressEdit(postData) {
    return fly.post(config.mallApi + "center/address/edit", postData);
  },
  /*	设置默认收货地址	center/address/default/set
   */
  centerAddressDefaultSet(addressId) {
    return fly.get(config.mallApi + "center/address/default/set/" + addressId)
  },
  /*	品牌商品列表	dbcenter/getBrandbcenter/findAllCategory
   */
  dbcenterGetBrand() {
    return fly.get(config.mallApi + "dbcenter/getBrand")
  },
  /*	产地列表	dbcenter/findAllCategory
   */
  dbcenterFindAllCategory() {
    return fly.post(config.mallApi + "dbcenter/findAllCategory")
  },
  /*	加入购物袋	shopping/cart/add
        productId   		商品ID
        productDetailId		商品详情ID
        count				商品购买数量
        */
  shoppingCartAdd(postData) {
    return fly.post(config.mallApi + "shopping/cart/add", postData)
  },
  /*	购物袋列表	shopping/cart/detail
        productId   		商品ID
        productDetailId		商品详情ID
        count				商品购买数量/order/list/pay
        */
  shoppingCartDetail() {
    return fly.get(config.mallApi + "shopping/cart/detail")
  },
  /*	删除购物袋	shopping/cart/del
        productIds []  		商品ID
        detailIds  []		商品详情ID
        */
  shoppingCartDel(postData) {
    return fly.post(config.mallApi + "shopping/cart/del", postData)
  },
  /*	订单列表（全部）	order/list/all
        current size
        term  (int)		1(三个月) 2（今年内） 3其他
        */
  orderListAll(postData) {
    return fly.get(config.mallApi + "order/list/all", postData)
  },
  /*	订单列表 （待付款）	order/list/pay
        current size
        term  (int)		1(三个月) 2（今年内） 3其他
        */
  orderListPay(postData) {
    return fly.get(config.mallApi + "order/list/pay", postData)
  },
  /*	订单列表 （待收货）	order/list/shipment
        current size
        term  (int)		1(三个月) 2（今年内） 3其他
        */
  orderListShipment(postData) {
    return fly.get(config.mallApi + "order/list/shipment", postData)
  },
  /*	订单列表 （已完成）	order/list/complete
        current size
        */
  orderListComplete(postData) {
    return fly.get(config.mallApi + "order/list/complete", postData)
  },
  /*	订单列表 （已关闭）	order/list/close
        current size
        */
  orderListClose(postData) {
    return fly.get(config.mallApi + "order/list/close", postData)
  },
  /*	-我的关注列表	center/favorite/list
             current--当前页
             size -- 条数
        */
  favoriteList(current, size) {
    return fly.get(config.mallApi + "center/favorite/list?current=" + current + "&size=" + size)
  },
  /*	-我的足迹列表（浏览记录）	center/look
             current--当前页
             size -- 条数
        */
  lookList(current, size) {
    return fly.get(config.mallApi + "center/app/look/list?current=" + current + "&size=" + size)
  },
  /*	取消订单	order/cancel
        orderId  订单id
        */
  orderCancel(orderId) {
    return fly.post(config.mallApi + "order/cancel/" + orderId)
  },
  /*	确认收货	order/receipt/
        current size
        */
  orderReceipt(orderId) {
    return fly.get(config.mallApi + "order/receipt/" + orderId)
  },
  /*	售后申请记录	sales/list
        current size
        */
  salesList(postData) {
    return fly.post(config.mallApi + "sales/list", postData)
  },
  /*	售后申请前准备数据	sales/applyPre
   */
  salesApplyPre(orderId, postData) {
    return fly.get(config.mallApi + "sales/applyPre/" + orderId, postData)
  },
  /*	售后申请列表	sales/serviceList
        current size
        searchType 1:近一个月2:近三个月 3:近半年
        */
  salesServiceList(postData) {
    return fly.post(config.mallApi + "sales/serviceList", postData)
  },
  /*	售后申请	sales/apply
        orderId 			订单ID
        orderItemId 		订单项ID
        serviceType 		服务类型  1 退款退货 2 仅退款
        reason 				退款理由
        returnCount			退款数量
        issureDesc			描述
        images				图片（最少一张）
        */
  salesApply(postData) {
    return fly.post(config.mallApi + "sales/apply", postData)
  },
  /*	售后详情	sales/detail/
        serviceId 			服务id
        */
  salesDetail(serviceId) {
    return fly.get(config.mallApi + "sales/detail/" + serviceId)
  },
  /*	买家退货	sales/returnGoods
        serviceId 			服务id
        trackingNo			物流单号
        corpId				物流公司ID
        phone				联系电话
        memo				备注
        */
  salesReturnGoods(postData) {
    return fly.post(config.mallApi + "sales/returnGoods", postData)
  },
  /*	参与拼团人数列表	goods/detail/groupbuy
        productId	int		是	商品id
        productDetailId	int		是	商品项Id
        activityId	int		否	活动Id
        */
  goodsDetailGroupbuy(postData) {
    return fly.post(config.mallApi + "goods/detail/groupbuy", postData)
  },
  /*	摇号中奖的人	goods/detail/awardee
        productId	int		是	商品id
        productDetailId	int		是	商品项Id
        activityId	int		否	活动Id
        */
  goodsDetailAwardee(postData) {
    return fly.post(config.mallApi + "goods/detail/awardee", postData)
  },
  /*	订单详情	order/detail
   */
  orderDetail(orderId) {
    return fly.get(config.mallApi + "order/detail/" + orderId)
  },
  /*	撤销售后申请	sales/cancel
   */
  salesCancel(severId) {
    return fly.get(config.mallApi + "sales/cancel/" + severId)
  },
  /*	报名参与 摇号活动	order/submit/activityOrder
   */
  orderSubmitActivityOrder(postData) {
    return fly.post(config.mallApi + "order/submit/activityOrder", postData)
  },
  /*	报名参与 摇号活动	order/list/2
   */
  orderList(postData) {
    return fly.get(config.mallApi + "order/list/" + postData.status, postData)
  },


  /*	钱包支付	walletPay/initPay
        orderNo	string	255	订单号（*）
        businessType	int	-	业务类型 1 订单支付 2 摇号报名费支付
        tradePwd	string	-	交易密码（*）
        */
  walletPayInitPay(postData) {
    return fly.post(config.mallApi + "walletPay/initPay", postData)
  },
  /*	产地品牌分类	app/findAllCategorys
   */
  appFindAllCategorys() {
    return fly.get(config.mallApi + "dbcenter/app/findAllCategory")
  },
  /*	品牌列表	dbcenter/app/getBrand
   */
  dbcenterAppGetBrand(brandId) {
    return fly.get(config.mallApi + "dbcenter/app/getBrand/" + brandId)
  },
  /*	立即购买，去结算 	shopping/cart/sold/settlement
  productId	int	商品id
  productDetailId	int	商品项ID
  count	int	数量
  isPromotion	int	是否参与活动 0 参与（默认）1 不参与
        */
  shoppingCartSoldSettlement(postData) {
    return fly.post(config.mallApi + "shopping/cart/sold/settlement", postData)
  },
  /*	运费计算 	order/calculateFreight
  addressId	int	-	收货地址ID(*)
  productDetailId	int	-	商品购买属性ID(*)
  productId	int	-	商品ID(*)
  quantity	int	-	购买数(*)
        */
  orderCalculateFreight(postData) {
    return fly.post(config.mallApi + "order/calculateFreight", postData)
  },
  /*	购物车到去结算 	shopping/cart/settlement
  cartItemIds	array	-	购物车itemId
        */
  shoppingCartSettlement(postData) {
    return fly.post(config.mallApi + "shopping/cart/settlement", postData)
  },
  /*	修改购物车数量 shopping/cart/edit
          productId	int	--	商品ID （*）
          productDetaild	int	-	商品购买属性Id(*)
          count	int	-	修改数量 （*）
        */
  shoppingCartEdit(postData) {
    return fly.post(config.mallApi + "shopping/cart/edit", postData)
  },
  /*	微信支付 	weixin/h5Pay
   */
  weixinH5Pay(postData) {
    return fly.post(config.mallApi + "weixin/h5Pay", postData)
  },
  /*	支付宝支付 	alipay/payment
   */
  alipayPayment(postData) {
    return fly.post(config.mallApi + "alipay/payment", postData)
  },
  /*	银联支付 	unionpay/consume
   */
  unionpayConsume(postData) {
    return fly.post(config.mallApi + "unionpay/consume", postData)
  },
  /*
  微信支付  weixin/h5Pay
  */
  wxPay: function(postData) {
    return fly.post(config.mallApi + 'weixin/h5Pay', postData);
  },

  //单桶定制列表
  customList: function(postData) {
    return fly.post(config.mallApi + '/customization/queryCustomizationList', postData)
  },
  //单桶定制详情
  customizationDetail: function(customizationId) {
    return fly.get(config.mallApi + '/customization/queryCustomizationDetail/' + customizationId);
  },
  //单桶众筹列表
  crowdfunding: function(postData) {
    return fly.post(config.mallApi + '/crowdfunding/list', postData);
  },
  //单桶众筹详情
  crowdfundingDetails: function(id) {
    return fly.get(config.mallApi + '/crowdfunding/detail/' + id);
  },

  //详情里面的我要支持
  crowdfundingSupport: function(id) {
    return fly.get(config.mallApi + 'crowdfunding/support/' + id);
  },

  //合同详情
  contractDetails: function(id) {
    return fly.get(config.mallApi + '/customization/getContractInformation/' + id)
  },
  //定制流程
  customProcess: function(id) {
    return fly.get(config.mallApi + 'customization/queryCustomizationStep/' + id)
  },
  //商品评价
  findEvaluateList: function(postData) {
    return fly.post(config.mallApi + "evaluate/findEvaluateList", postData);
  },
  //优惠券领取列表
  // 入参 {current，size，type1领券中心列表2商城首页轮播图列表3商品详情内部领券列表	}
  couponList: function(postData) {
    return fly.post(config.mallApi + 'discountCoupon/queryDiscountCouponList', postData)
  },
  //已领取的优惠券列表
  CouponRecordList: function(postData) {
    return fly.post(config.mallApi + 'discountCoupon/queryDiscountCouponRecordList', postData)
  },
  //优惠券领取提交
  setCoupon: function(postData) {
    return fly.post(config.mallApi + 'discountCoupon/saveDiscountCouponRecord', postData)
  },
  //获取优惠券信息
  getCouponDetails(id) {
    return fly.get(config.mallApi + 'discountCoupon/getDiscountCouponDetailByCode/' + id)
  },
  //购物车返回数量
  shoppingNum() {
    return fly.get(config.mallApi + 'shopping/cart/shoppingNum')
  },
  //活动商品
  activityGoodsList(id) {
    return fly.get(config.mallApi + 'goods/selectActivityProductListByType?activityType=' + id)
  },
  //限时抽奖获取页面信息
  queryLuckyDrawActivity(id) {
    return fly.get(config.mallApi + 'luckyDrawActivity/queryLuckyDrawActivity/' + id)
  },
  //参与抽奖 
  participationLuckyDraw(postData) {
    return fly.post(config.mallApi + 'luckyDrawActivity/participationLuckyDraw', postData)
  },
  //提交中奖用户物流信息
  ///api/luckyDrawActivity/
  insertReceivingInformation(postData) {
    return fly.post(config.mallApi + 'luckyDrawActivity/insertReceivingInformation', postData)
  },
  //会员礼包
  ///api/knight/gift/queryPage
  queryKnightGift(postData) {
    return fly.post(config.mallApi + 'knight/gift/queryPage', postData)
  },
  //领取会员礼包
  ///api/knight/gift/draw
  knightGiftDraw(postData) {
    return fly.post(config.mallApi + 'knight/gift/draw', postData)
  },
  //查询购物车数量
  ///api/shopping/cart/shoppingNum
  queryShoppingNum() {
    return fly.get(config.mallApi + 'shopping/cart/shoppingNum')
  }
}

export default mApi



// WEBPACK FOOTER //
// ./src/utils/api/mApi.js